import useIsLoggedIn from '@apps/www/src/www/hooks/useIsLoggedIn';
import useTrackUpgradeClick from '@apps/www/src/www/hooks/useTrackUpgradeClick';
import SVA from '@pkgs/shared-client/components/SVA';
import SVButton from '@pkgs/shared-client/components/SVButton';
import SVDropdownContent from '@pkgs/shared-client/components/SVDropdownContent';
import SVUpgradeButton from '@pkgs/shared-client/components/SVUpgradeButton';
import UpgradeButtonSource from '@pkgs/shared/enums/UpgradeButtonSource';
import React from 'react';

// TODO: Need to sync with SVUpgradeButton props automatically
const SVTrackedUpgradeButtonContainer = ({
	...props
}: React.PropsWithChildren<{
	source: ValueOf<typeof UpgradeButtonSource>;
	onClick?: () => void | false;
	to?: string;
	className?: string;
	title?: string;
	target?: string;
}> &
	(
		| ({
				Component?: typeof SVButton;
		  } & Pick<React.ComponentProps<typeof SVButton>, 'use' | 'size'>)
		| {
				Component: typeof SVA | typeof SVDropdownContent.Links.ItemLink | 'a';
		  }
	)) => {
	const isLoggedIn = useIsLoggedIn();
	const trackUpgradeClick = useTrackUpgradeClick();

	return (
		<SVUpgradeButton isLoggedIn={isLoggedIn} trackUpgradeClick={trackUpgradeClick} {...props} />
	);
};

export default SVTrackedUpgradeButtonContainer;
